export default __webpack_public_path__ + "static/media/computer.28497094.svg";